import { render, staticRenderFns } from "./GestionMetodoEnvio.vue?vue&type=template&id=38b901dc&scoped=true"
import script from "./GestionMetodoEnvio.vue?vue&type=script&lang=js"
export * from "./GestionMetodoEnvio.vue?vue&type=script&lang=js"
import style0 from "./GestionMetodoEnvio.vue?vue&type=style&index=0&id=38b901dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b901dc",
  null
  
)

export default component.exports